import styled from "styled-components";
import breakpoints from "../../../../constants/breakpoints";

export const Styles = styled.div`
  width: ${({ width }) => width};
  position: relative;

  .input {
    height: 40px;
    position: relative;
    border: none;
    background: transparent;
    z-index: -1;

    &:focus {
      box-shadow: none;
      background-color: transparent !important;
    }

    &:focus-visible {
      outline: none;
    }
    .select {
      border: none;
    }
  }

  input[type="date"]::-webkit-calendar-picker-indicator {
    position: absolute;
    left: 0;
  }

  input::-webkit-datetime-edit-fields-wrapper {
    position: relative;
    left: 15px;
  }
  .date-placeholder {
    display: flex;
    flex-direction: row-reverse;
    height: 40px;
    align-items: center;
    justify-content: space-between;
    border-radius: var(--border-radius);
    border: ${({ errorMessage, validateOnChange, borderColor }) =>
      errorMessage && validateOnChange
        ? "1px solid var(--danger) !important"
        : borderColor
        ? `1px solid ${borderColor} !important`
        : "1px solid white !important"};
  }
  .icon {
    svg {
      font-size: 25px;
      color: #aeabab;
    }
  }
  label {
    color: black;
    position: absolute;
    top: 1px;
    width: 100%;
    height: 36px;
    cursor: pointer;
    padding: 0.5rem;
    background-color: #f9fafb !important;
    display: flex;
    align-items: center;
    span {
      margin-left: 0.5rem;
    }
  }
  .date-inputs {
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: 36px;
    width: auto;
    background: white;
    z-index: 2;
    padding: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  .year-picker {
    position: absolute;
    top: 41px;
    @media (max-width: ${breakpoints.ipadPro}) {
      top: 53px;
    }
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #d1d5db;
    border-radius: var(--border-radius);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 10;
    max-height: 200px;
    overflow-y: auto;
  }

  .year-picker-content {
    padding: 8px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 4px;
  }

  .year-option {
    padding: 8px 12px;
    text-align: center;
    cursor: pointer;
    border-radius: 4px;
    font-size: 14px;
    transition: all 0.2s ease;

    &:hover {
      background-color: #f3f4f6;
    }

    &.selected {
      background-color: var(--main-blue);
      color: white;
    }
  }
  @media (max-width: ${breakpoints.sm}) {
    width: 100% !important;
  }
  @media (max-width: ${breakpoints.ipadPro}) {
    .input {
      height: 50px !important;
    }
    label {
      margin-top: 12px;
    }
  }
`;
